// @flow

export type SourceType = "direct" | "lc01" | "lc02" | "lc03" | "lc04";

export const imageUrl = "https://cstatic-801.cdn.nextologies.com/videojs3/Associated_Press_logo_2012.svg";
